import { render } from "./tentangKami.vue?vue&type=template&id=f83bbe6c"
import script from "./tentangKami.vue?vue&type=script&lang=js"
export * from "./tentangKami.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__